import GLightbox from 'glightbox';

export default class Lightbox {
    constructor() {
        this.imageLightbox();

        if ( document.body.classList.contains( 'template-post-detail' ) || document.body.classList.contains( 'template-news-archive') ) {
            this.contentLightbox();
        }
    }

    imageLightbox() {
        let elements = document.querySelectorAll( '*[data-gallery]' );

        const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
            <div class="gloader visible"></div>
            <div class="goverlay"></div>
            <div class="gcontainer">
            <div id="glightbox-slider" class="gslider"></div>
            <div class="gcount">
             <span class="gcount-current"></span>
             <span class="gcount-separator">/</span>
             <span class="gcount-total"></span>
            </div>
            <button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example"><i class="icon-arrow-right"></i></button>
            <button class="gprev gbtn" tabindex="1" aria-label="Previous"><i class="icon-arrow-left"></i></button>
            <button class="gclose gbtn" tabindex="2" aria-label="Close"><i class="icon-plus"></i></button>
        </div>
        </div>`;

        elements.forEach( ( element ) => {
            let galleryID = element.getAttribute( 'data-gallery');
            let images = element.querySelectorAll( '[data-lightbox]' );
            let elements = [];

            const lightbox = GLightbox( {
                touchNavigation: true,
                closeOnOutsideClick: true,
                zoomable: false,
                draggable: false,
                openEffect: 'fade',
                closeEffect: 'fade',
                height: 500,
                lightboxHTML: customLightboxHTML
            } );

            images.forEach( ( image, index ) => {
                elements[ index ] = {
                    href: image.getAttribute( 'data-lightbox' )
                }

                image.addEventListener( 'click', () => {
                    lightbox.openAt( index );
                } );
            } );

            lightbox.setElements( elements );

            lightbox.on('open', () => {
                const totalElement = document.querySelector( '.gcount-total' );
                totalElement.innerHTML = elements.length;

                const currentElement = document.querySelector( '.gcount-current' );
                currentElement.innerHTML = lightbox.getActiveSlideIndex() + 1;
            });
              
            lightbox.on('slide_changed', ({ prev, current }) => {
                const currentElement = document.querySelector( '.gcount-current' );
                currentElement.innerHTML = current.slideIndex + 1;
            });
        } );
    }

    contentLightbox() {
        const lightboxContent = GLightbox( {
            selector: '.text-content a[href*=".jpg"]',
            touchNavigation: true,
            closeOnOutsideClick: true,
            zoomable: false,
            openEffect: 'fade',
            closeEffect: 'fade',
            height: 'auto'
        } );
    }
}